import TopicStatistics from './TopicStatistics';

export default TopicStatistics;
